import { compose } from "redux";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core/styles";

import { Format } from "app/app.constants";
import layoffIcon from "assets/Layoff.svg";
import { formatDate } from "utils/format.util";
import quarantineIcon from "assets/Biohazard.svg";
import { WORK_SCHEDULE_OVERRIDE_REASONS } from "features/planner/planner.constants";
import { workScheduleOverrideReasonToString } from "features/planner/planner.mappers";

export const visibleWorkScheduleOverrideReasons = [
  WORK_SCHEDULE_OVERRIDE_REASONS.LAYOFF,
  WORK_SCHEDULE_OVERRIDE_REASONS.QUARANTINE,
];

const overrideReasonIcons = {
  [WORK_SCHEDULE_OVERRIDE_REASONS.LAYOFF]: layoffIcon,
  [WORK_SCHEDULE_OVERRIDE_REASONS.QUARANTINE]: quarantineIcon,
};

class EmployeeCardWorkScheduleIcon extends PureComponent {
  getWorkScheduleOverrideTitle = currentWorkScheduleOverride => {
    return `${workScheduleOverrideReasonToString(
      currentWorkScheduleOverride.get("overrideReason"),
    )} (${formatDate(
      currentWorkScheduleOverride.get("startDate"),
      Format.workSchedule,
    )} - ${formatDate(
      currentWorkScheduleOverride.get("endDate"),
      Format.workSchedule,
    )})`;
  };

  render() {
    const { classes, workScheduleOverride } = this.props;

    const overrideReason = workScheduleOverride.get("overrideReason");

    if (!visibleWorkScheduleOverrideReasons.includes(overrideReason)) {
      return null;
    }

    return (
      <img
        className={classes.root}
        src={overrideReasonIcons[overrideReason]}
        alt={workScheduleOverrideReasonToString(overrideReason)}
        title={this.getWorkScheduleOverrideTitle(workScheduleOverride)}
      />
    );
  }
}

const styles = theme => ({
  root: {
    height: theme.spacing(2.5),
    fontWeight: theme.typography.fontWeightMedium,
  },
});

export default compose(withStyles(styles))(EmployeeCardWorkScheduleIcon);
